import { declareVueComponent } from '/vodalys/vvuejs'

import VrunFormTextfieldCellComponent from './VrunFormTextfieldCellComponent.vue'

declareVueComponent('vrun-form-textfield-cell-component', VrunFormTextfieldCellComponent)